export const louiseBotImageUrl = 'https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png';

export const advancedPopoverImageUrl =
  'https://cdn.1cdn.app/application/LOUISEBOT/24120308072691_page_text_chatbot_fully_customizable_to_reflect_your_brand.png';
